import React, { useState, useRef, forwardRef } from "react";
import { Anchor } from "@zendeskgarden/react-buttons";
import { UnorderedList } from "@zendeskgarden/react-typography";

const MenuItem = forwardRef(({ item, title, level }, ref) => {
  const RenderIndentUnit = ({}) => {
    const indentUint = [];
    for (let i = 1; i < level; i++) {
      indentUint.push(<span class="zd-tree-option-indent-unit" />);
    }
    return indentUint;
  };
  const scrollToElement = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <li
        className={`zd-tree-option zd-tree-option-level${level}`}
        data-key={item.key}
        id={item.id}
        onClick={() => scrollToElement(item.id)}
      >
        <span className="zd-tree-option-indet">
          <RenderIndentUnit />
        </span>
        <UnorderedList>
          <Anchor isUnderlined={false} href={`#${item.id}`}>
            {title}
          </Anchor>
        </UnorderedList>
      </li>
      {item.children?.length > 0 && (
        <ul>
          {item.children.map((child, index) => {
            return <MenuItem key={index} title={child.title} item={child} level={level + 1} />;
          })}
        </ul>
      )}
    </>
  );
});
export default MenuItem;
